class Loader {
	constructor () {
		this.container = document.querySelector('#venues-detail-loader')
		this.addLoader()
	}

	addLoader () {
		this.loader = this._createLoader()
		this.container.append(this.loader)
	}

	_createLoader () {
		const loader = document.createElement('div')
		loader.innerHTML = /* html */`
			<div class="d-flex justify-content-center mt-5">
				<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
			</div>
		`
		return loader
	}

	turnOn () {
		this.container.style['display'] = 'block'
	}

	turnOff () {
		this.container.style['display'] = 'none'
	}
}

export default Loader



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/views/Loader.js